"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _types = require("../types");

var getBackgroundColor = function getBackgroundColor(disabled, type, c) {
  if (disabled) return c.grey.f;

  switch (type) {
    case _types.ButtonTypes.SECONDARY:
      return c.grey.b;

    case _types.ButtonTypes.TERTIARY:
      return c.grey.h;

    case _types.ButtonTypes.WHITE:
      return c.white.a;

    case _types.ButtonTypes.PRODUCT:
      return c.blue.a;

    default:
      return c.black.a;
  }
};

var _default = getBackgroundColor;
exports.default = _default;